import styled from '@emotion/styled';
import React from 'react';

export const ProgressBar = ({
  percentage,
  height,
}: {
  percentage: number;
  height: number;
}) => {
  return (
    <ProgressBarWrapper height={height}>
      <Bar width={percentage} height={height} />
    </ProgressBarWrapper>
  );
};

const ProgressBarWrapper = styled.div<{ height: number }>`
  width: 100%;
  background: #ebeced;
  position: relative;
  height: ${({ height }) => `${height}px`};
  border-radius: 42px;
  margin: 16px 0 12px;
  overflow: hidden;
`;
const Bar = styled.div<{ width: number; height: number }>`
  width: ${({ width }) => width}%;
  background: #5000b9;
  position: absolute;
  height: ${({ height }) => `${height}px`};
  transition: width 300ms ease-in-out;
`;
